export const documentationSections = [
  { id: 'getting-started', title: 'Getting Started' },
  { id: 'authentication', title: 'Authentication' },
  { id: 'api-reference', title: 'API Reference' },
  { id: 'sdk-integration', title: 'SDK Integration' },
  { id: 'webhooks', title: 'Webhooks' },
  { id: 'examples', title: 'Examples' }
];
